import client from 'client';

import { SERVER_URL } from 'constants/index';

const bulkDownload = (transferId, header = {}) => {
  async function getBulkDownloadId(transferId) {
    const resp = await client.post(`${SERVER_URL}/api/v1/transfers/${transferId}/bulkdownload`,{},
    {
      headers: header
    })
    return resp.reference_id;
  }
  
  async function getBulkDownloadStatus(referenceId) {
    return await client.get(`${SERVER_URL}/api/v1/transfers/tasks/${referenceId}/status`,
      {
          headers: header
      }
    )
  }
  
  function pingBulkDownloadId(referenceId, resolve, reject) {
    if (referenceId) {
        const STATUS = {
            COMPLETE: 'COMPLETE',
            FAILED: 'FAILED'
        }
    
        setTimeout(function () {
            getBulkDownloadStatus(referenceId)
            .then(function (results) {
              const result = results.filter(result => result.id === referenceId).pop();

              if (!result) {
                pingBulkDownloadId(referenceId, resolve, reject);
              } else if (result.status === STATUS.FAILED) {
                reject(new Error(result.data));
              } else if (result.status === STATUS.COMPLETE) {
                initializeDownload(result.data.download_url);
                resolve();
              } else {
                // TODO: Localize error message
                reject(new Error('Unexpected bulk download status from server'));
              }
            })
            .catch(function (e) {
                reject(e);
            });
        }, 300);
    }
  }
  
  function initializeDownload(url) {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = 'midrive.zip';
    anchor.click();
  }

  const process = async () => {
    const id = await getBulkDownloadId(transferId);

    return new Promise((resolve, reject) => {
      pingBulkDownloadId(id, resolve, reject);
    })
  }

  return {
    process
  }
};

export default bulkDownload;
